import isEmpty from 'lodash/isEmpty'

import { Course } from '@mc/api'
import { useStaticData } from '@mc/static-data-react'
import { EventTypes, PageSource } from '@mc/track-event'
import { SOURCES } from '@mc/share'

import { HighContrastHero } from 'components/HighContrastHero'
import { TrackProps } from 'components/HighContrastHero/events'
import { getIsSeries } from 'libs/utils'
import { type DynamicHeroValues, useCMDynamicHero } from 'libs/dynamic-hero'

const getTrackProps = (course: Course): TrackProps => ({
  eventName: EventTypes.COURSE_MARKETING_CLICK,
  slug: course.slug,
  pageCategory: 'class',
  pageSource: PageSource.CLASS_PAGE,
})

const getTrailerProps = (course: Course) => ({
  brightcoveVideoId: course?.brightcoveVideoId,
  mediaUuid: course?.mediaUuid,
  instructorName: course.instructorName,
  headline: course.headline,
  id: course.id,
  slug: course.slug,
  title: course.title,
  instructorAvatar: course.primary1x1,
})

const getSampleProps = (course: Course) => ({
  brightcoveVideoId: course?.sample?.brightcoveVideoId,
  mediaUuid: course?.sample?.mediaUuid,
  instructorName: course.instructorName,
  headline: course.headline,
  id: course.id,
  title: course.title,
  slug: course.slug,
})

const getShareProps = (course: Course) => ({
  slug: course.slug,
  instructorName: course.instructorName || '',
  id: course.id,
  headline: course.headline || '',
  source: SOURCES.CLASS_GUEST_NEXT,
})

export const Hero = () => {
  const { course, savedDynamicHero } = useStaticData<{
    course: Course
    savedDynamicHero: DynamicHeroValues
  }>()
  const { header, subheader, nameplate } = useCMDynamicHero({
    useCourseDefaultValues: true,
  })

  const isDynamicNameplate =
    !isEmpty(savedDynamicHero) &&
    savedDynamicHero?.nameplate !== course.nameplate

  const desktopImage = getIsSeries(course.type)
    ? course?.image16x9
    : course?.cinematic12x5

  return (
    <HighContrastHero
      desktopImage={desktopImage}
      mobileImage={course?.image2x3}
      header={header}
      subheader={subheader}
      nameplate={nameplate}
      nameplateAlt={course.instructorName}
      alternativeNameplate={isDynamicNameplate}
      trackProps={getTrackProps(course)}
      trailerProps={getTrailerProps(course)}
      sampleProps={getSampleProps(course)}
      shareProps={getShareProps(course)}
    />
  )
}
